<script>
import routes_mixin from "../../../mixins/routes_mixin";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import BadgeBlock from "../../slots/BadgeBlock.vue";
import EditIcon from "../../icons/EditIcon.vue";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../../store/modules/notifiocation";
import {mapActions} from "vuex";
import DefaultTitle from "../../small_components/DefaultTitle.vue";
import {axiosCompanyEquipment, axiosUserEquipment, axiosUserEquipmentUrl} from "../../../helpers/axios_requests";
import TextareaEditor from "../../small_components/TextareaEditor.vue";
import DefaultSelect from "../../small_components/DefaultSelect.vue";
import {ValidationObserver} from "vee-validate";
import DefaultButton from "../../small_components/DefaultButton.vue";
import {FORMAT_ERROR_MESSAGE } from '../../../helpers/validation_error_message';
import {NEW_USER_EQUIPMENT} from "../../../helpers/new_objects";
import DefaultBox from "../../slots/DefaultBox";
import Switcher from "../../small_components/Switcher.vue";
import {ROUTES_NAMES} from "../../../router";

export default {
  name: 'CompanyEquipmentView',
  components: {
    Switcher,
    DefaultButton,
    ValidationObserver,
    DefaultSelect, TextareaEditor, DefaultTitle, EditIcon, BadgeBlock, DefaultInput, RouterLinkTo, DefaultBox},
  mixins: [routes_mixin],

  data() {
    return {
      getUserRoleIsAdmin: true,
      user_equipment: [],
      loading: true,
      equipments: []
    }
  },

  created() {
    this.loading = false;
    this.fetchUserEquipment(this.get_id())
  },

  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    searchFetchList() {
      return true;
    },

    fillData(data) {
      this.equipments = data || []
      this.equipments.forEach(async (equipment) => {
        if (equipment.user_equipment == null) {
          equipment.user_equipment = NEW_USER_EQUIPMENT()
        } else {
          equipment.user_equipment.issued = true;
        }
      });
      console.log(this.equipments)
    },

    fetchUserEquipment(id) {
      this.loading = true
      axiosUserEquipment.get(id)
          .then(r => {
            this.fillData(r.data.items)
          })
          .finally(() => {
            this.loading = false
          })
    },

    createUpdate() {
      axiosUserEquipment.createUpdate({id: this.get_id(), equipments: this.equipments})
          .then((r) => {
            if (r.data.errors) {
              this.$refs.form.setErrors(r.data.errors);
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            this.actionPushNotification({message: 'Saved', status: STATUS_SUCCESS})
          }).catch((r) => {
        console.log(r)
      }).finally(() => {
        this.loading = false
        this.fetchUserEquipment(this.get_id())
      })
    },

    changeIssued(equipment, value) {
      equipment.user_equipment.issued = value.checked
    },

    get_id() {
      return Number(this.$route.params.id)
    },

    checkedIssued(equipment) {
      return equipment?.user_equipment.id !== 0
    },

    isCheckedIssued(equipment) {
      return equipment?.user_equipment.issued
    }
  }
}
</script>

<template>
  <div class="user-layout">
    <badge-block>
      <default-title h_tag="h3">
        {{ $t('articles.article_info') }}
      </default-title>
      <default-box class="position-relative"
                   :loader="loading">
        <div class="row dashboard-wrapper  mt-20">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header">{{ $t('equipment.equipment') }}</h5>
              <div class="card-body">
                <ValidationObserver v-slot="{ invalid, passes }" ref="form">
                  <form
                        class="row mt-20"
                        @submit.prevent="passes(createUpdate)">
                    <template v-for="equipment in equipments">
                      <div class="col-md-12 col-12 mb-10">
                        <default-title
                            h_tag="h5"
                        >
                          {{equipment.title}}
                        </default-title>
                      </div>
                      <div class="col-md-12 col-12 mb-10">
                        <switcher
                            :placeholder="$t('equipment.issued')"
                            :checked="checkedIssued(equipment)"
                            @change="changeIssued(equipment, $event)"
                        />
                      </div>
                      <div class="col-md-12 col-12 mb-10" v-if="equipment.identifier">
                        <default-input
                            :label="$t('equipment.identifier')"
                            v-model="equipment?.user_equipment.identifier"
                        />
                      </div>
                    </template>

                    <div class="text-end mt-20 sticky-bottom">
                      <default-button
                          button_large
                          type="submit">
                        {{ $t('inputs.save') }}
                      </default-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </default-box>
    </badge-block>
  </div>
</template>
